export const SESSION_NAME = "stock_manager";
